import { useState, useEffect } from 'react';
import { urls } from '../../../../config';

export const useFetchData = (dataIds, destination) => {
  let [returnData, setReturnData] = useState([]);

  useEffect(() => {
    if (!destination || dataIds?.length === 0) return;

    let url = `${urls.cms}/${destination}/?_fields=title,acf`;
    for (const pl of dataIds) {
      url += `&include[]=${pl}`;
    }
    
    const controller = new AbortController();
    fetch(url, { signal: controller.signal })
      .then((response) => response.json())
      .then((data) => {
        setReturnData(data || []);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('Fetch error:', err);
        }
      });

    return () => controller.abort();
  }, [dataIds, destination]);

  return returnData;
};

export default useFetchData;
